import React, { useEffect, useMemo } from "react";
import HTMLFlipBook from "react-pageflip";

const Page = React.forwardRef(({ src, index }, ref) => {
  return (
    <div
      ref={ref}
      className="h-full w-full overflow-hidden bg-white select-none"
    >
      <img
        src={src}
        alt={`Página ${index + 1} del catálogo`}
        className="h-full w-full object-contain"
        draggable={false}
      />
    </div>
  );
});

Page.displayName = "Page";

export default function CatalogFlipbook({ open, onClose }) {
  const pages = useMemo(() => {
    return Array.from({ length: 98 }, (_, i) => {
      const page = String(i + 1).padStart(4, "0");
      return `/img/catalogo/catalogo_page-${page}.jpg`;
    });
  }, []);

  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      <div className="catalog-overlay" onClick={onClose}>
        <div className="catalog-modal" onClick={(e) => e.stopPropagation()}>
          <div className="catalog-topbar">
            <div>
              <h3 className="catalog-title">Catálogo completo</h3>
              <p className="catalog-subtitle">
                Desliza o haz clic para pasar páginas
              </p>
            </div>

            <button
              type="button"
              onClick={onClose}
              className="catalog-close"
              aria-label="Cerrar catálogo"
            >
              ×
            </button>
          </div>

          <div className="catalog-book-wrap">
            <HTMLFlipBook
              width={360}
              height={510}
              minWidth={220}
              maxWidth={700}
              minHeight={300}
              maxHeight={780}
              size="stretch"
              maxShadowOpacity={0.24}
              showCover={true}
              mobileScrollSupport={true}
              drawShadow={true}
              flippingTime={900}
              usePortrait={true}
              startZIndex={10}
              autoSize={true}
              clickEventForward={true}
              useMouseEvents={true}
              swipeDistance={30}
              showPageCorners={true}
              disableFlipByClick={false}
              className="catalog-book"
              style={{}}
              startPage={0}
            >
              {pages.map((src, index) => (
                <Page key={src} src={src} index={index} />
              ))}
            </HTMLFlipBook>
          </div>
        </div>
      </div>

      <style>{`
        .catalog-overlay{
          position: fixed;
          inset: 0;
          z-index: 9999;
          background: rgba(8, 14, 14, 0.62);
          backdrop-filter: blur(14px);
          -webkit-backdrop-filter: blur(14px);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }

        .catalog-modal{
          width: min(1320px, 100%);
          height: min(92vh, 940px);
          border-radius: 32px;
          overflow: hidden;
          background: linear-gradient(
            180deg,
            rgba(255,255,255,0.85),
            rgba(255,255,255,0.76)
          );
          border: 1px solid rgba(255,255,255,0.7);
          box-shadow: 0 35px 100px rgba(0,0,0,0.28);
          display: flex;
          flex-direction: column;
        }

        .catalog-topbar{
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 14px;
          padding: 18px 20px;
          border-bottom: 1px solid rgba(54,107,99,0.10);
          background: rgba(255,255,255,0.52);
          flex: 0 0 auto;
        }

        .catalog-title{
          margin: 0;
          font-size: 16px;
          font-weight: 700;
          color: rgba(54,107,99,1);
        }

        .catalog-subtitle{
          margin: 4px 0 0;
          font-size: 12px;
          color: rgba(54,107,99,0.68);
        }

        .catalog-close{
          width: 42px;
          height: 42px;
          border-radius: 999px;
          border: 1px solid rgba(54,107,99,0.12);
          background: rgba(255,255,255,0.88);
          color: rgba(54,107,99,1);
          font-size: 20px;
          font-weight: 700;
          cursor: pointer;
          transition: transform .2s ease, background .2s ease;
        }

        .catalog-close:hover{
          transform: scale(1.04);
          background: rgba(255,255,255,1);
        }

        .catalog-book-wrap{
          flex: 1 1 auto;
          min-height: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 18px 24px 24px;
          overflow: hidden;
          background:
            radial-gradient(circle at center, rgba(255,255,255,.24), rgba(255,255,255,0) 55%),
            linear-gradient(180deg, #dfe8e6 0%, #eef3f2 100%);
        }

        .catalog-book{
          max-width: 100%;
          max-height: 100%;
          box-shadow: 0 30px 80px rgba(0,0,0,.22);
          border-radius: 22px;
        }

        @media (max-width: 768px){
          .catalog-modal{
            height: 90vh;
            border-radius: 22px;
          }

          .catalog-topbar{
            padding: 14px 16px;
          }

          .catalog-book-wrap{
            padding: 10px 10px 14px;
          }
        }
      `}</style>
    </>
  );
}